<template>
  <div
    class="selectBox"
    tabindex="0"
    ref="wrapper"
    @mousedown.stop.prevent="toggle"
    @keydown.enter.prevent="toggle"
    @keydown.esc.stop="close"
    @keydown.arrow-down.prevent="selectNext"
    @keydown.arrow-up.prevent="selectPrev"
  >
    <div v-if="open" class="select-dropdown">
      <div
        v-for="item in items"
        :key="item.key"
        class="select-option"
        :class="{ 'is-active': item.key === selected }"
        @mousedown.stop.prevent="select(item)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasisCalcSelectEditor",

  data() {
    return {
      open: false,
      selected: null,
      items: [
        { key: "hour", title: "ساعتی" },
        { key: "daily", title: "روزانه" },
      ],
    };
  },

  mounted() {
    this.selected = this.params.value ?? "monthDays";

    this.$nextTick(() => {
      this.open = true;
      this.$refs.wrapper?.focus();
      this.$refs.select?.focus();
    });

    document.addEventListener("mousedown", this.handleOutsideClick);
  },

  beforeDestroy() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  },

  methods: {
    selectNext() {
      const index = this.items.findIndex((i) => i.key === this.selected);
      const next = this.items[index + 1] || this.items[0];
      this.selected = next.key;
    },

    selectPrev() {
      const index = this.items.findIndex((i) => i.key === this.selected);
      const prev = this.items[index - 1] || this.items[this.items.length - 1];
      this.selected = prev.key;
    },
    toggle() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
      this.params.stopEditing();
    },
    select(item) {
      this.selected = item.key;
      this.open = false;
      this.params.stopEditing();
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.close();
      }
    },
    getValue() {
      return this.selected;
    },
    isPopup() {
      return true;
    },
  },
};
</script>

<style scoped>
.editor-input {
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  background: #fff;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.editor-text {
  flex: 1;
  text-align: center;
  font-size: 15px;
  color: #555;
}

.arrow {
  width: 10px;
  height: 10px;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
  transform: rotate(45deg);
  margin-left: 6px;
}

.select-dropdown {
  position: absolute;
  top: -5px;
  right: 2px;
  width: 100%;
  background: #fff;
  border: 1px solid #c1bebe;
  border-radius: 4px;
  z-index: 1000;
  cursor: pointer;
}

.select-option {
  padding: 4px 6px;
  cursor: pointer;
  width: 80px;
  background-color: #fff;
  border: 1px solid #c1bebe;
}

.select-option:hover {
  background-color: #dddadae6;
}
.select-option.is-active {
  background-color: #dddadae6;
}
.is-placeholder {
  color: #c6c2c2;
}
</style>
